export default ".user-toolbar {\n  background: transparent !important;\n  height: 40px;\n  margin-top: -40px;\n}";